import { render, staticRenderFns } from "./HistogramSparkline.vue?vue&type=template&id=a09a4ad4&scoped=true"
import script from "./HistogramSparkline.vue?vue&type=script&lang=js"
export * from "./HistogramSparkline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a4ad4",
  null
  
)

export default component.exports